import React, { useEffect, useState } from "react";

import {
  SimpleGrid,
  Button,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  Box,
} from "@chakra-ui/react";

import VaraService from "../../../../../../main/services/VaraService";
import RadioGroupTable from "../../../../../components/RadioGroupTable";
import FiltersRadioGroupTable from "../../../../../components/FiltersRadioGroupTable";
import LoadingSpinner from "../../../../../components/LoadingSpinner";
import SemRegistros from "../../../../../components/SemRegistros";

const VaraModal = ({ isOpen, onOpen, onClose, selected, setSelected }) => {
  const [data, setData] = useState();
  const [loading, setLoading] = useState(true);
  const [tempSelected, setTempSelected] = useState();

  const columns = [
    {
      Header: "Nome",
      accessor: "nome",
      Cell: (props) => {
        return <span title={props.value}>{props.value}</span>;
      },
    },
    {
      Header: "Comarca",
      accessor: "comarca",
      Cell: (props) => {
        return <span>{props.value}</span>;
      },
    },
  ];

  useEffect(() => {
    if (isOpen === true) {
      VaraService.getVaras()
        .then((res) => {
          setLoading(false);
          setData(res.data);
        })
        .catch((error) => console.log(error));
    }
  }, [isOpen]);

  const handleTemporarySelection = (value) => {
    setTempSelected(value);
  };

  const handleSelection = () => {
    if (tempSelected) {
      setSelected(tempSelected);
    }
    onClose();
  };

  return (
    <>
      <Modal
        isOpen={isOpen}
        onClose={onClose}
        size="6xl"
        scrollBehavior={"inside"}
      >
        <ModalOverlay />
        <ModalContent
          p={{ base: "15px", md: "25px" }}
          w={{ base: "100%", lg: "70%" }}
          bgColor="#FFF"
        >
          <ModalHeader
            p="0px"
            fontWeight={700}
            fontSize="14px"
            lineHeight="19.6px"
            color="#95BCBF"
          >
            PESQUISAR VARA DA INFÂNCIA
          </ModalHeader>
          <ModalBody p="0px" mt="25px">
            <FiltersRadioGroupTable
              setData={setData}
              entidade="vara"
              setLoading={setLoading}
            />

            {!loading ? (
              <>
                {!!data && data?.length > 0 ? (
                  <RadioGroupTable
                    data={data}
                    columns={columns}
                    selected={selected}
                    setSelected={handleTemporarySelection}
                  />
                ) : (
                  <Box mt="4">
                    <SemRegistros buttonVisible={true} half />
                  </Box>
                )}
              </>
            ) : (
              <Box mt="4">
                <LoadingSpinner loading={loading} />
              </Box>
            )}
          </ModalBody>

          <ModalFooter p="0px" mt="15px" justifyContent="center">
            <SimpleGrid
              mt="20px"
              columns={2}
              spacing="15px"
              w={{ base: "100%", lg: "40%" }}
            >
              <Button
                id="button-voltar-vara"
                color="#FFF"
                backgroundColor="#169499"
                fontWeight={700}
                fontSize="15px"
                lineHeight="21.6px"
                _hover={{ bg: "#169499" }}
                onClick={onClose}
              >
                Voltar
              </Button>
              <Button
                id="button-selecionar-vara"
                color="#FFF"
                backgroundColor="#169499"
                fontWeight={700}
                fontSize="15px"
                lineHeight="21.6px"
                _hover={{ bg: "#169499" }}
                onClick={handleSelection}
                isDisabled={tempSelected === undefined}
              >
                Selecionar
              </Button>
            </SimpleGrid>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
};

export default VaraModal;
